var App = App || {};

App.BlockVideo = (function ($) {
   'use strict';

   function init() {

       $(".block-video").each(function () {

           const Video = $(this);

           // click to stop all other videos before playing the clicked video
           Video.find(".block-video-button").click(function () {
               Play(Video);
           });

           // if the video is in a modal, stop it from playing after modal close
           const Modal = $(this).parents(".modal");
           if (Modal.length > 0) {
               Modal.on("shown.bs.modal", function () {
                   Play(Video);
               });
               Modal.on("hidden.bs.modal", function () {
                   Stop(Video);
               });
           }

       });
   }

   function Play(Video) {

       // stop all other videos before starting a new one
       $(".block-video").each(function () { Stop($(this)); });

       const Target = Video.find(".block-video-placeholder");
       const Button = Video.find(".block-video-button");
       const Source = Button.attr("data-src");
       const Title = Button.attr("data-title");

       switch (true) {
           case Source.toLowerCase().indexOf("youtube") >= 0:
               Target.html(Youtube(Source, Title))
               break;
           case Source.toLowerCase().indexOf("vimeo") >= 0:
               Target.html(Vimeo(Source, Title));
               break;
           default:
               console.log("Could not locate video content");
       };

       Button.hide();
       Target.show();
   }

   function Stop(Video) {

       const Target = Video.find(".block-video-placeholder");
       const Button = Video.find(".block-video-button");

       Target.hide().html("");
       Button.show();
   }

   function Youtube(Source, Title) {
       var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
       return Template;
   }

   function Vimeo(Source, Title) {
       var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
       return Template;
   }

   return {
       init: init
   };

})(jQuery);

$(function () {
   App.BlockVideo.init();
});
